/**
 * Shopify Multi-Currency Price Filter Fix for Galeria
 * Converts price filter min/max values from default currency (EUR) to the active currency
 * and updates live when customer switches currency.
 */

function updatePriceFilters() {
  if (!window.Shopify || !Shopify.currency || !Shopify.currency.active || !Shopify.currency.rates) return;

  const activeCurrency = Shopify.currency.active;
  const defaultCurrency = "EUR"; // store default

  if (activeCurrency === defaultCurrency) return; // No conversion needed

  const conversionRate = Shopify.currency.rates[activeCurrency];
  if (!conversionRate) return;

  const priceFilters = document.querySelectorAll('[data-facet-type="price"]');
  priceFilters.forEach((filter) => {
    const minAttr = filter.getAttribute("data-min");
    const maxAttr = filter.getAttribute("data-max");
    if (!minAttr || !maxAttr) return;

    const minValue = Math.round(Number(minAttr) * conversionRate);
    const maxValue = Math.round(Number(maxAttr) * conversionRate);

    filter.setAttribute("data-min", minValue);
    filter.setAttribute("data-max", maxValue);

    // Update labels if present
    const minLabel = filter.querySelector(".price-min");
    const maxLabel = filter.querySelector(".price-max");
    if (minLabel) minLabel.textContent = Shopify.formatMoney(minValue * 100, Shopify.money_format);
    if (maxLabel) maxLabel.textContent = Shopify.formatMoney(maxValue * 100, Shopify.money_format);
  });
}

// Run on page load after slight delay to allow filters to render
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(updatePriceFilters, 500);
});

// Run on currency change events
document.addEventListener("shopify:currency-change", function () {
  setTimeout(updatePriceFilters, 100); // slight delay to let currency update
});
